import {Component, OnInit} from '@angular/core';
import {CSCProviders, CscService} from "../../services/CscService";
import {ActivatedRoute} from "@angular/router";
import {CookieService} from "ngx-cookie-service";
import {CscSignDocService} from "../../services/CscSignDocService";
import {NgIf} from "@angular/common";
import {KnobModule} from "primeng/knob";
import {FormsModule} from "@angular/forms";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-callback',
    standalone: true,
    imports: [
        NgIf,
        KnobModule,
        FormsModule,
        TranslatePipe
    ],
    templateUrl: './callback.component.html',
    styleUrl: './callback.component.scss'
})
export class CallbackComponent implements OnInit {
    code!: string | null;
    state!: string | null;

    inProgress: boolean = true;
    isError: boolean = false;

    //csccallback
    intervalId: any = 0;
    value: number = 0;
    url!: string;

    constructor(private cscService: CscService,
                private route: ActivatedRoute,
                private cookieService: CookieService,
                private cscSignDocService: CscSignDocService) {
    }

    ngOnInit(): void {
        this.getCSCParameter();

        this.intervalId = setInterval(() => {
            this.value = (this.value + 5) % 101;
        }, 500);
    }

    getCSCParameter(): void {

        this.route.queryParams.subscribe(params => {
            this.code = params['code'] || null;
            this.state = params['state'] || null;
            const urlerror = params['error'] || null;

            if (!this.code || !this.state || urlerror) {
                this.isError = true;
                return
            }
            this.startSignDoc(this.code, this.state);
        });
    }

    startSignDoc(code: string, subItemId: string) {
        this.inProgress = true;
        // get access token
        this.cscService.postForAccessToken(code, subItemId).subscribe({
            next: (response) => {

                console.log(response);
                //this.signHashes(response.credentialID, response.access_token);
                this.cookieService.set('csc_access_token', response.access_token);
                this.cookieService.set('csc_credentialID', response.credentialID);

                this.signDoc(subItemId, response.credentialID, response.access_token);
                //this.signHashes(subItemId, response.credentialID, response.access_token)

            },
            error: (error) => {
                clearInterval(this.intervalId);
                this.isError = true;
                console.log(error);
            }
        });
    }


    signDoc(subItemId: string, credentialID: string, credential_access_token: string) {
        this.isError = false;
        this.cscSignDocService.postSignDoc(subItemId, credentialID, credential_access_token).subscribe({
            next: (response) => {
                const blob = new Blob([response], {type: 'application/pdf'});

                // Bestehende URL ggf. zuerst aufräumen
                if (this.url) {
                    URL.revokeObjectURL(this.url);
                }

                // URL speichern für spätere Verwendung
                this.url = URL.createObjectURL(blob);
                this.inProgress = false;

                // Beispiel: Download-Link erzeugen
                //const link = document.createElement('a');
                //link.href = this.url; // ✅ dauerhafte URL
                //link.download = 'signed-document.pdf';
                //link.click();
                this.setSigningResult(subItemId)
            },
            error: (error) => {
                this.isError = true;
                console.log('Fehler beim Abrufen des Dokuments:', error);
                clearInterval(this.intervalId);
                this.inProgress = false;
            }
        });
    }

    setSigningResult(docId: string) {
        clearInterval(this.intervalId);
    }

    signHashes(subItemId: string, credentialID: string, credential_access_token: string) {
        this.cscService.postSignHashes(subItemId, credentialID, credential_access_token).subscribe({
            next: (response) => {
                console.log(response);
            },
            error: (error) => {
                console.log(error);
            }
        });
    }
}
